import _ from 'lodash';
import createjs from 'createjs-collection';

import { cjsDnD } from './cjsDnD';

export class cjsMixer extends cjsDnD {
  _crossP;
  _mixing;
  _txtPixels;
  _pixels;

  constructor(obj) {
    super(obj);

    this._crossP = {};
    this._mixing = new createjs.Container();
    this._mixing.name = 'Mixing';
  }

  create() {
    super.create();
    this.container.cache(0, 0, this.width, this.height);
  }

  stageMouseDown(e, data) {
    console.log('cjsMixer: DOWN');
    super.stageMouseDown(e, data);
  }

  stageMouseUp(e, data) {
    console.log('cjsMixer: UP');
    super.stageMouseUp(e, data);
  }

  _stageMouseMove(e, data) {
    let engine = data.engine,
      stage = data.cjsStage;

    if (stage.mousedown !== true || engine._mousedown !== true) {
      e.stopPropagation();
      return false;
    }
    if (engine.thrown !== false) {
      engine._removeFromThrown(stage);
    }
    engine.container.filters = [];
    engine.container.updateCache();

    super._stageMouseMove(e, data);

    if (engine.otherProperty.inLine === true && engine.thrown !== false) {
      let correct = false;
      for (let i = 0; i < engine.correct.length; i++) {
        if (engine.correct[i].idGroup == engine.thrown.idGroup && engine.correct[i].idItem == engine.thrown.idItem) {
          correct = true;
          break;
        }
      }
      if (!correct) {
        engine._removeFromThrown(stage);
        engine.thrown = false;
      }
    }
    if (engine.thrown === false) {
      return;
    }

    let target = stage.groups[engine.thrown.idGroup].items[engine.thrown.idItem];
    var pt = engine.container.parent.localToGlobal(engine.x, engine.y);
    //var pt2 = target.container.parent.localToGlobal(target.x, target.y);
    var pt3 = target.container.globalToLocal(pt.x, pt.y);
    //var pt4 = engine.container.localToLocal(pt3.x, pt3.y, target.container);
    engine._checkMixerCollision(
      {
        p: { x: 0, y: 0 },
        w: engine.width,
        h: engine.height,
      },
      {
        p: pt3,
        w: target.width,
        h: target.height,
      }
    );

    let crop = new createjs.Bitmap(engine.container.cacheCanvas);
    crop.sourceRect = new createjs.Rectangle(engine._crossP.x, engine._crossP.y, engine._crossP.w, engine._crossP.h);
    crop.x = engine._crossP.cX;
    crop.y = engine._crossP.cY;

    let mask = new createjs.Bitmap(target.container.cacheCanvas);
    mask.cache(engine._crossP.cX, engine._crossP.cY, target.width, target.height);
    crop.filters = [new createjs.AlphaMaskFilter(mask.cacheCanvas)];
    crop.cache(0, 0, target.width, target.height);
    crop.idGroup = engine.idGroup;
    crop.id = engine.id;

    let cropEngine = new createjs.Bitmap(target.container.cacheCanvas);
    cropEngine.sourceRect = new createjs.Rectangle(
      engine._crossP.cX,
      engine._crossP.cY,
      engine._crossP.w,
      engine._crossP.h
    );
    cropEngine.x = engine._crossP.x;
    cropEngine.y = engine._crossP.y;

    let maskEngine = new createjs.Bitmap(engine.container.cacheCanvas);
    maskEngine.cache(engine._crossP.x, engine._crossP.y, engine.width, engine.height);
    cropEngine.filters = [new createjs.AlphaMaskFilter(maskEngine.cacheCanvas)];
    cropEngine.cache(0, 0, engine._crossP.w, engine._crossP.h);

    let imgData = cropEngine.cacheCanvas.getContext('2d').getImageData(0, 0, engine._crossP.w, engine._crossP.h);

    for (let i = 0; i < imgData.data.length; i += 4) {
      imgData.data[i] = 255;
      imgData.data[i + 1] = 0;
      imgData.data[i + 2] = 0;
      if (imgData.data[i + 3] < 100) {
        imgData.data[i + 3] = 255;
      } else {
        imgData.data[i + 3] = 0;
      }
    }
    cropEngine.cacheCanvas.getContext('2d').putImageData(imgData, 0, 0);

    let contMask = new createjs.Container();
    contMask.addChild(new createjs.Shape(new createjs.Graphics().f('#ff0000').dr(0, 0, engine.width, engine.height)));
    contMask.cache(0, 0, engine.width, engine.height);
    contMask.cacheCanvas.getContext('2d').putImageData(imgData, cropEngine.x, cropEngine.y);

    engine.container.filters = [new createjs.AlphaMaskFilter(contMask.cacheCanvas)];

    engine.container.updateCache(0, 0, engine.width, engine.height);

    crop.alpha = 0.5;
    target._mixing.addChild(crop);

    target.container.addChild(target._mixing);
    target.container.updateCache();
    target.container.removeChild(target._mixing);
  }

  _removeFromThrown(stage) {
    let target = stage.groups[this.thrown.idGroup].items[this.thrown.idItem],
      self = this;
    target._mixing.children.forEach(function (child, index, parent) {
      if (child.id === self.id && child.idGroup === self.idGroup) {
        parent.splice(index, 1);
      }
    });
    if (target._mixing.children.length > 0) {
      target.container.addChild(target._mixing);
      target.container.updateCache();
      target.container.removeChild(target._mixing);
    } else {
      target.container.updateCache();
    }
  }

  _checkMixerCollision(c1, c2) {
    let w = 0,
      h = 0;

    // I:
    if (c1.p.x < c2.p.x && c2.p.x < c1.p.x + c1.w && c1.p.y < c2.p.y && c2.p.y < c1.p.y + c1.h) {
      w = c2.w < c1.w - (c2.p.x - c1.p.x) ? c2.w : c1.w - (c2.p.x - c1.p.x);
      h = c2.h < c1.h - (c2.p.y - c1.p.y) ? c2.h : c1.h - (c2.p.y - c1.p.y);
      // console.log('I');

      this._crossP.w = w;
      this._crossP.h = h;
      this._crossP.x = 0;
      this._crossP.y = 0;

      this._crossP.cX = c2.w - w - (c2.w - c1.w);
      this._crossP.cY = c2.h - h - (c2.h - c1.h);
    }
    // II:
    else if (c1.p.x < c2.p.x && c2.p.x < c1.p.x + c1.w && c2.p.y < c1.p.y && c2.p.y + c2.h > c1.p.y) {
      w = c2.w < c1.w - (c2.p.x - c1.p.x) ? c2.w : c1.w - (c2.p.x - c1.p.x);
      h = c1.h < c2.h - (c1.p.y - c2.p.y) ? c1.h : c2.h - (c1.p.y - c2.p.y);
      // console.log('II');

      this._crossP.w = w;
      this._crossP.h = h;
      this._crossP.x = 0;
      this._crossP.y = c2.h - h;
      if (h == c1.h) {
        this._crossP.y -= this._crossP.y + c2.p.y;
      }

      this._crossP.cX = c2.w - w - (c2.w - c1.w);
      this._crossP.cY = 0;
    }
    // III:
    else if (c1.p.x > c2.p.x && c1.p.x < c2.p.x + c2.w && c1.p.y > c2.p.y && c1.p.y < c2.p.y + c2.h) {
      w = c1.w < c2.p.x + c2.w - c1.p.x ? c1.w : c2.p.x + c2.w - c1.p.x;
      h = c1.h < c2.p.y + c2.h - c1.p.y ? c1.h : c2.p.y + c2.h - c1.p.y;
      // console.log('III');

      this._crossP.w = w;
      this._crossP.h = h;
      this._crossP.x = c2.w - w;
      this._crossP.y = c2.h - h;
      if (h == c1.h) {
        this._crossP.y -= this._crossP.y + c2.p.y;
      }

      this._crossP.cX = 0;
      this._crossP.cY = 0;
    }
    // IV:
    else if (c1.p.x > c2.p.x && c1.p.x < c2.p.x + c2.w && c1.p.y < c2.p.y && c2.p.y < c1.p.y + c1.h) {
      w = c1.w < c2.p.x + c2.w - c1.p.x ? c1.w : c2.p.x + c2.w - c1.p.x;
      h = c2.h < c1.p.y + c1.h - c2.p.y ? c2.h : c1.p.y + c1.h - c2.p.y;
      // console.log('IV');

      this._crossP.w = w;
      this._crossP.h = h;
      this._crossP.x = c2.w - w;
      this._crossP.y = 0;

      this._crossP.cX = 0;
      this._crossP.cY = c2.h - h - (c2.h - c1.h);
    }

    return w * h;
  }
}

cjsMixer.checkGameAction = function (stage, droped) {
  console.log('cjsMixer CHECK');

  return cjsDnD.checkGameAction(stage, droped);
};
